import { render, staticRenderFns } from "./NDEEnvelopeCardPersonalisationModal.vue?vue&type=template&id=47b796dd&scoped=true&"
import script from "./NDEEnvelopeCardPersonalisationModal.vue?vue&type=script&lang=js&"
export * from "./NDEEnvelopeCardPersonalisationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b796dd",
  null
  
)

export default component.exports